module.exports = __webpack_public_path__ + "img/earn_post.b52256b6.svg";